import React from 'react';

interface NumberFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  step?: number;
  helpText?: string;
}

const NumberField: React.FC<NumberFieldProps> = ({ label, value, onChange, min = 0, step = 1, helpText }) => (
  <label className="block">
    <div className="mb-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-100/55">{label}</div>
    <input
      type="number"
      min={min}
      step={step}
      value={Number.isFinite(value) ? value : 0}
      onChange={(event) => onChange(Number(event.target.value))}
      className="w-full rounded-2xl border border-white/10 bg-[#120807] px-4 py-3 text-white placeholder:text-white/35 focus:border-amber-400/35 focus:outline-none"
    />
    {helpText && <div className="mt-2 text-sm text-white/45">{helpText}</div>}
  </label>
);

export default NumberField;

